import {Field} from "react-final-form";
import {
  Box,
  Divider,
  IconButton,
} from "@mui/material";
import {SVGProps, useLayoutEffect, useRef} from "react";
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
  isLoading?: boolean
  fieldName: string;
  onPrintComplete: (number: string) => Promise<void>;
  getCharacterInput?: number;
  styles: any;
  disabled?: boolean;
  label?: string
};

const SearchSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    {...props}
  >
    <path
      d="M21 3C11.621 3 4 10.621 4 20s7.621 17 17 17c3.71 0 7.14-1.195 9.938-3.219l13.156 13.125 2.812-2.812-13-13.032A16.923 16.923 0 0 0 38 20c0-9.379-7.621-17-17-17Zm0 2c8.297 0 15 6.703 15 15s-6.703 15-15 15S6 28.297 6 20 12.703 5 21 5Z"/>
  </svg>
)

export const WidgetPlateFieldSearch = (props: Props) => {
  const {fieldName, getCharacterInput = 0, styles, disabled = false} = props;
  const refInput = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    refInput.current?.focus();
  }, []);

  return (
    <Field
      autoFocus={true}
      name={fieldName}
      maxLength={8}
      type={"text"}
      parse={(value) => {
        if (disabled) {
          return value;
        }
        return (
          value
            .replace(/\s/g, "")
            .match(/.{1,4}/g)
            ?.join(" ")
            .substr(0, 8) || ""
        );
      }}
      render={(values) => {
        return (
          <div className={styles.plateField}>
            <div className={styles.label}>
              {values.input.value ? '' : 'Enter your reg number and press search'}
            </div>
            <div className={styles.fields}>
              <div className={styles.type}>
                <span>GB</span>
              </div>
              <div className={styles.numbers}>
                <Box sx={{
                  position: 'relative',
                  display: 'flex',
                  verticalAlign: 'middle'
                }}>
                  <input
                    ref={refInput}
                    {...values.input}
                    maxLength={8}
                    disabled={disabled}
                    className={styles.input}
                    onKeyDown={async ev => {
                      if (ev.key === 'Enter') {
                        ev.preventDefault();
                        await props.onPrintComplete(values.input.value)
                      }
                    }}
                  />
                  {/*<div style={{*/}
                  {/*  position:'relative'*/}
                  {/*}}>*/}
                  {/*{["6%", "18%", "30%", "42%", "", "60%", "72%", "84%"]*/}
                  {/*  .slice(getCharacterInput)*/}
                  {/*  .map((item, i) => (*/}
                  {/*    <span*/}
                  {/*      key={i}*/}
                  {/*      style={{*/}
                  {/*        left: item,*/}
                  {/*        display:*/}
                  {/*          values.input.value[i] || i === 4*/}
                  {/*            ? "none"*/}
                  {/*            : "block",*/}
                  {/*      }}*/}
                  {/*      className={styles.marks}*/}
                  {/*    >*/}
                  {/*      </span>*/}
                  {/*  ))}*/}
                  {/*</div>*/}
                  <Divider sx={{height: '100%'}} orientation="vertical"/>
                  <IconButton
                    size={'small'}
                    className={styles.search}
                    disabled={props.isLoading || !values.input.value}
                    style={{
                      height: '100%',
                      borderRadius: '0 12px 12px 0'
                    }}
                    onClick={async (ev) => {
                      ev.preventDefault();
                      await props.onPrintComplete(values.input.value)
                      refInput.current?.focus();
                    }}
                    color="primary"
                    sx={{p: '10px'}}
                    aria-label="directions">
                    {props.isLoading ?
                      <CircularProgress size={'1em'} color={'primary'}/> :
                      <SearchSvg
                        width={'1em'}
                        height={'1em'}
                        fill={!values.input.value ? '#939393' : '#003399'}
                      />
                    }
                  </IconButton>
                </Box>
              </div>
            </div>
          </div>
        );
      }
      }
    />
  );
}

